exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".updatePermissionsForm .fields .field-group{display:flex;align-items:flex-start}.updatePermissionsForm .fields .field-group>div:first-child{margin-right:1em}.updatePermissionsForm .fields .field-group>div:nth-child(2){flex:1}.updatePermissionsForm .fields .field-group label{text-transform:none;letter-spacing:0;font-size:1em}.updatePermissionsForm .fields .field-group input[name=group]{max-width:500px;margin-bottom:30px}.settings-form-container{width:100%;max-width:100%;margin:0;padding:1em;box-shadow:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/settings/PermissionsPage/permissionsForm.scss
// module id = 1034
// module chunks = 0